var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpain = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_377_6485)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 7.49914C0 8.41654 0.165029 9.29533 0.466494 10.1078L7.5 10.76L14.5335 10.1078C14.835 9.29533 15 8.41654 15 7.49914C15 6.58174 14.835 5.70295 14.5335 4.89046L7.5 4.23828L0.466494 4.89046C0.165029 5.70295 0 6.58174 0 7.49914H0Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5338 4.89132C13.4741 2.03534 10.725 0 7.5003 0C4.27557 0 1.52649 2.03534 0.466797 4.89132H14.5338Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.466797 10.1094C1.52649 12.9654 4.27557 15.0007 7.5003 15.0007C10.725 15.0007 13.4741 12.9654 14.5338 10.1094H0.466797Z",
  fill: "#D80027"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_377_6485"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpain);
export { ForwardRef as ReactComponent };